// extracted by mini-css-extract-plugin
module.exports = {"warning":"SuperAdminBar_warning__HOlzF","fixed":"SuperAdminBar_fixed__3DPgI","isSticky":"SuperAdminBar_isSticky__hNG4x"};